// extracted by mini-css-extract-plugin
module.exports = {"options":"styles-module__options___25f-2","option":"styles-module__option___1lbZu","placeholder":"styles-module__placeholder___3lyHC"};